import actions from '@synergycms_app/store/actions';
import moment from 'moment';

import { fromJS, OrderedMap, List, Map } from 'immutable';
import { union } from 'ramda';
import {filterAvailParams, filterAvailLoyaltyParams, filterAvailCalendarParams, filterAvailCacheParams, allowedCookieParams } from './paramsUtils';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import Cookies from '../../utils/cookies';

export const hotelCodeToId = hotelInfo => hotelCodes => {
  if (!hotelCodes) {
    return undefined;
  } else if (List.isList(hotelCodes)) {
    let currentId = hotelInfo
      .filter(info => {
        return hotelCodes.includes(info.get('code'));
      })
      .map(info => info.get('id'));

    if(!currentId.size){
      currentId = hotelInfo
        .filter(info => {
          return hotelCodes.includes(info.get('id'));
        })
        .map(info => info.get('id'));
    }
    return currentId;
  } else {
    let currentId = hotelInfo.find(hotel => hotelCodes === hotel.get('code'), null, Map()).get('id', undefined);
    if(!currentId){
      currentId = hotelInfo.find(hotel => hotelCodes === hotel.get('id'), null, Map()).get('id', undefined);
    }
    return currentId && currentId.toString();
  }
};

export const hotelIdToCode = hotelInfo => (hotelIds = '') => {
  if (!hotelIds) {
    return undefined;
  } else if (List.isList(hotelIds)) {
    return hotelInfo
      .filter(info => {
        return hotelIds.includes(info.get('id'));
      })
      .map(info => info.get('code'));
  } else {
    return hotelInfo.find(hotel => hotelIds.toString() === hotel.get('id'), null, Map()).get('code', undefined);
  }
};

export default {
  AVAIL_CACHE_PARAMS: (newParams) => (dispatch, getState) => {
    const store = getState();

    // Regex -> 03/12/2020
    /*const regexWrongFormatDate = new RegExp('^([0-2][0-9]|(3)[0-1])(\\/)(((0)[0-9])|((1)[0-2]))(\\/)\\d{4}$');
    let startDateStr = newParams.get('start');
    let endDateStr = newParams.get('end');

    if (regexWrongFormatDate.test(startDateStr)) {
      startDateStr = startDateStr.split('/').reverse().join('-');
    }
    if (regexWrongFormatDate.test(endDateStr)) {
      endDateStr = endDateStr.split('/').reverse().join('-');
    }

    const startDate =
      startDateStr && moment(startDateStr, 'YYYY-MM-DD') >= moment()
        ? startDateStr
        : moment().format('YYYY-MM-DD');
*/
    const prevParams = store.getIn(['customer', 'params', 'avail_cache_params'], OrderedMap({
      hotelId: newParams.get("hotelId"),
      language: store.getIn(['customer', 'lang', 'code']),
      date: moment().format("YYYY-MM-DD"),
      stay_length: 1,
      country: store.getIn(['customer', 'country', 'code']),
      source: 'wg',
      occups: fromJS({
        0: {
          adults: 2
        }
      }),
      refundability: 'any',
      city_id: newParams.get('city_id', null),
      country_id: newParams.get('country_id', null),
      group: newParams.get("group", "eurostarshotels"),
    }));

    const params = prevParams.merge(newParams);

    const availCacheParams = filterAvailCacheParams(params);

    return Map({
      avail_cache_params: availCacheParams,
      avail_cache_query_params: ParamsParser.paramsToQuery(availCacheParams),
    });
  },
  //Acció utilitzada per inicialitzar els parametres i corregirlos a partir del obj parsejat de la url
  CREATE_FROM_URL: (newParams, currentStep) => (dispatch, getState) => {
    const store = getState();
    const getterHotelCodeToId = hotelCodeToId(store.getIn(['hotels', 'hotels_info', 'hotels']));
    const requiredParams = store.getIn(['customer', 'step', 'required_params'], List());
    const isMultiAvail = currentStep.get('type') === 'multi';

    const oldParams = store.getIn(['customer', 'params', 'params']) || Map();
    // Regex -> 03/12/2020
    const regexWrongFormatDate = new RegExp('^([0-2][0-9]|(3)[0-1])(\\/)(((0)[0-9])|((1)[0-2]))(\\/)\\d{4}$');
    let startDateStr = newParams.get('start');
    let endDateStr = newParams.get('end');

    if (regexWrongFormatDate.test(startDateStr)) {
      startDateStr = startDateStr.split('/').reverse().join('-');
    }
    if (regexWrongFormatDate.test(endDateStr)) {
      endDateStr = endDateStr.split('/').reverse().join('-');
    }

    // Obtener config 
    const appConfig = store.getIn(['app', 'config'], Map());
    const disableRedirInvalidDate = appConfig.getIn(['disable_redir_invalid_date'], false);

    let startDate = startDateStr
    let endDate = endDateStr;

    if (!disableRedirInvalidDate) {
      startDate =
        startDateStr && moment(startDateStr, 'YYYY-MM-DD') >= moment()
          ? startDateStr
          : moment().format('YYYY-MM-DD');

      endDate =
        endDateStr && moment(endDateStr, 'YYYY-MM-DD') > moment(startDate, 'YYYY-MM-DD')
          ? endDateStr
          : moment(startDate)
            .add(1, 'days')
            .format('YYYY-MM-DD');
    }



    const corporateStore = store.getIn(['customer', 'corporate'], Map());

    const loyaltyUser =  store.getIn(['customer', 'loyalty','user'], null);

    const params = OrderedMap({
      hotels: isMultiAvail ? getterHotelCodeToId(newParams.get('hotelCodes'), List()) : List(),
      hotelId: !isMultiAvail && getterHotelCodeToId(newParams.get('hotelCode')),
      language: store.getIn(['customer', 'lang', 'code']),
      date: startDate,
      stay_length: moment(endDate).diff(moment(startDate), 'd', true),
      channel: newParams.get('channel') || 'Web',
      checkin_days: 1,
      country: store.getIn(['customer', 'country', 'code']),
      source: 'wg',
      occups: newParams.get(
        'occups',
        fromJS({
          0: {
            adults: 2
          }
        })
      ),
      refundability: 'all',
      promotion_code: newParams.get('promotion_code', null),
      gift_voucher: newParams.get('gift_voucher', null),
      company_id: newParams.get('company_id', null),
      referer_code: newParams.get('referer_code', null),
      skip_restrictions : true,
      avail_code:
        (Map.isMap(corporateStore) &&
          corporateStore.get('tipo_perfil', false) === '1' &&
          corporateStore.get('afiliado', false)) ||
        newParams.get('avail_code', newParams.get('referer_code', null)),
      daily_details: true,
      city_id: newParams.get('city_id', null),
      country_id: newParams.get('country_id', null),
      tdckehc: newParams.get('tdckehc', null),
      testing_mode: newParams.get('testing_mode', null),
      extended_testing_mode: newParams.get('extended_testing_mode', null),
      from_tms: newParams.get('from_tms', null),
      tms_tracking: newParams.get('tms_tracking', null),
      prepayment_id: newParams.get('prepayment_id', null),
      prepayment_amount: newParams.get('prepayment_amount', null),
      POS: newParams.get('POS', null),
      currency: newParams.get('currency', null),
      pin: newParams.get('pin', null),
      utm_source: newParams.get('utm_source', null),
      utm_medium: newParams.get('utm_medium', null),
      utm_campaign: newParams.get('utm_campaign', null),
      tracking_id: newParams.get('tracking_id', null),
      utm_term: newParams.get('utm_term', null),
      refid: newParams.get('refid', null),
      td: newParams.get('td', null),
      msclkid: newParams.get('msclkid', null),
      trv_reference: newParams.get('trv_reference', null),
      clickID: newParams.get('clickID', null),
      gclid: newParams.get('gclid', null),
      yclid: newParams.get('yclid', null),
      selection_avail: newParams.get('selection_avail', null),
      tt_meta: newParams.get('tt_meta', null),
      tt_gha_campaign_id: newParams.get('tt_gha_campaign_id', null),
      tt_ad_type: newParams.get('tt_ad_type', null),
      tt_adults: newParams.get('tt_adults', null),
      tt_checkin: newParams.get('tt_checkin', null),
      tt_checkout: newParams.get('tt_checkout', null),
      tt_children: newParams.get('tt_children', null),
      tt_date_type: newParams.get('tt_date_type', null),
      tt_los: newParams.get('tt_los', null),
      tt_partner_id: newParams.get('tt_partner_id', null),
      tt_user_country: newParams.get('tt_user_country', null),
      tt_user_device: newParams.get('tt_user_device', null),
      room_id: newParams.get("room_id", oldParams.get("room_id", null)),
      qt_tracking_id: newParams.get('qt_tracking_id', null),
      loyalty : loyaltyUser && loyaltyUser.get('level'),
      _askSI: newParams.get('_askSI', null)
    });

    //modo testing

      newParams.get('testing_mode', false) || newParams.get('extended_testing_mode', false);

    const newValidParams = ParamsParser.paramsToUrl(
      params.merge(
        isMultiAvail ? Map({ hotelCodes: newParams.get('hotelCodes') }) : Map({ hotelCode: newParams.get('hotelCode') })
      ),
      union(requiredParams.toJS(), newParams.keySeq().toJS())
    );


    dispatch(actions.customer.params.availCacheParams(params));
    const calendarSearchParams = filterAvailCalendarParams(params)
      .set('refundability', 'any')
      .set('stay_length', 1);

    const loyaltyParams = filterAvailLoyaltyParams(params);

    return Map({
      url_params: newValidParams,
      params: params,
      query_params: ParamsParser.paramsToQuery(filterAvailParams(params)),
      loyalty_params: loyaltyParams,
      loyalty_query_params: ParamsParser.paramsToQuery(loyaltyParams),
      calendar_params: calendarSearchParams,
      calendar_query_params: ParamsParser.paramsToQuery(calendarSearchParams)
    });
  },
  //acció utilitzada per modificar els parametres un cop ja els tenim inicialitzats, en aquest cas rebem un inmutable del params de store
  UPDATE_PARAMS: (newParams = Map(), type) => (dispatch, getState) => {
    const store = getState();
    if (newParams && newParams.get('hotelId', null)) {
      newParams = newParams.set('hotelId', newParams.get('hotelId').toString());
    }
    let params = store.getIn(['customer', 'params', 'params']);
    if (params.get("room_id")) {
      params = params.set("room_id", null);
    }

    const updatedParams = params.merge(newParams);

    const getterHotelIdToCode = hotelIdToCode(store.getIn(['hotels', 'hotels_info', 'hotels']));

    const hotelCodes = getterHotelIdToCode(updatedParams.get('hotels')) || List();
    const hotelCode = getterHotelIdToCode(updatedParams.get('hotelId'));

    const newValidParams = ParamsParser.paramsToUrl(
      updatedParams.merge(hotelCode ? Map({ hotelCode: hotelCode }) : Map({ hotelCodes: hotelCodes })),
      union(store.getIn(['customer', 'step', 'required_params'], List()).toJS(), updatedParams.keySeq().toJS())
    );
    //const validParams = !!(newValidParams.get('hotelCode') || newValidParams.get('hotelCodes', List()).size);

    // Control para verificar que si vamos a una dispo sin promotion_code, hay que limpiar la cookie si existiese
    if(!newValidParams.get('promotion_code')) {
      Cookies.unset('promotion_code');
    }

    const calendarSearchParams = filterAvailCalendarParams(updatedParams)
      .set('refundability', 'any')
      .set('stay_length', 1);

    dispatch(actions.customer.params.availCacheParams(newValidParams));


    const loyaltyParams = filterAvailLoyaltyParams(updatedParams);

    return fromJS({
      url_params: newValidParams,
      params: updatedParams,
      query_params: ParamsParser.paramsToQuery(filterAvailParams(updatedParams)),
      loyalty_params: loyaltyParams,
      loyalty_query_params: ParamsParser.paramsToQuery(loyaltyParams),
      calendar_params: calendarSearchParams,
      calendar_query_params: ParamsParser.paramsToQuery(calendarSearchParams)
    });
  }
};
